import {
  SET_USER_ID,
  SET_CLIENT_ID,
  SET_EMAIL_ADDRESS,
  SET_HAS_ONBOARDED,
  SET_IS_ON_WEB,
  RECORD_DATA_CLIENT_ID,
  RECORD_DATA_CLIENT_IDS,
  REGISTER_LOGGED_IN,
  REGISTER_LOGGED_OUT,
  SET_CURRENT_APP_STATE_TO_DASHBOARD,
  SET_CURRENT_APP_STATE_TO_APP,
} from '../constants/ActionTypes'

/**
 * @typedef {ReturnType<typeof setUserId> | ReturnType<typeof setClientId> | ReturnType<typeof setEmailAddress> | ReturnType<typeof setHasOnboarded> | ReturnType<typeof setIsOnWeb> | ReturnType<typeof recordDataClientId> | ReturnType<typeof recordDataClientIds> | ReturnType<typeof registerLoggedIn> | ReturnType<typeof registerLoggedOut> | ReturnType<typeof legacy__setCurrentAppStateToDashboard> | ReturnType<typeof legacy__setCurrentAppStateToApplication>
} ClientActions
 */

/**
 * @param {String | Null} userId
 * @return {{ type: 'SET_USER_ID', userId: String | Null }}
 */
export const setUserId = (userId) => ({
  type: SET_USER_ID,
  userId,
})

/**
 * @param {String | Null} clientId
 * @return {{ type: 'SET_CLIENT_ID', clientId: String | Null }}
 */
export const setClientId = (clientId) => ({
  type: SET_CLIENT_ID,
  clientId,
})

/**
 * @param {String | Null} emailAddress
 * @return {{ type: 'SET_EMAIL_ADDRESS', emailAddress: String | Null }}
 */
export const setEmailAddress = (emailAddress) => ({
  type: SET_EMAIL_ADDRESS,
  emailAddress,
})

/**
 * @param {boolean} hasOnboarded
 * @return {{ type: 'SET_HAS_ONBOARDED', hasOnboarded: boolean }}
 */
export const setHasOnboarded = (hasOnboarded) => ({
  type: SET_HAS_ONBOARDED,
  hasOnboarded,
})

/**
 * @return {{ type: 'SET_IS_ON_WEB' }}
 */
export const setIsOnWeb = () => ({
  type: SET_IS_ON_WEB,
})

/**
 * @param {String} path
 * @param {String} clientId
 * @return {{ type: 'RECORD_DATA_CLIENT_ID', path: String, clientId: String }}
 */
export function recordDataClientId(path, clientId) {
  return { type: RECORD_DATA_CLIENT_ID, path, clientId }
}

/**
 * @param {Array<String>} paths
 * @param {String} clientId
 * @return {{ type: 'RECORD_DATA_CLIENT_IDS', paths: Array<String>, clientId: String }}
 */
export function recordDataClientIds(paths, clientId) {
  return { type: RECORD_DATA_CLIENT_IDS, paths, clientId }
}

/**
 * @return {{ type: 'REGISTER_LOGGED_IN' }}
 */
export function registerLoggedIn() {
  return { type: REGISTER_LOGGED_IN }
}

/**
 * @return {{ type: 'REGISTER_LOGGED_OUT' }}
 */
export function registerLoggedOut() {
  return { type: REGISTER_LOGGED_OUT }
}

/**
 * @return {{ type: 'SET_CURRENT_APP_STATE_TO_DASHBOARD' }}
 */
export function legacy__setCurrentAppStateToDashboard() {
  return { type: SET_CURRENT_APP_STATE_TO_DASHBOARD }
}

/**
 * @return {{ type: 'SET_CURRENT_APP_STATE_TO_APP' }}
 */
export function legacy__setCurrentAppStateToApplication() {
  return { type: SET_CURRENT_APP_STATE_TO_APP }
}
